import { Outlet, Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';

const roleHome: Record<string, string> = {
  SUPER_ADMIN: '/dashboard', INSTITUTION_ADMIN: '/dashboard',
  PARENT: '/my-payments', STUDENT: '/my-wallet', CAFETERIA: '/cafeteria/dashboard',
};

export function AuthLayout() {
  const { isAuthenticated, user } = useAuthStore();
  if (isAuthenticated) return <Navigate to={roleHome[user?.role ?? ''] ?? '/dashboard'} replace />;

  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden bg-[#07070f]">
      {/* Glows de fondo */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            'radial-gradient(ellipse 70% 55% at 15% 35%, rgba(10,129,188,0.25) 0%, transparent 65%),' +
            'radial-gradient(ellipse 55% 45% at 85% 75%, rgba(255,117,31,0.14) 0%, transparent 60%)',
        }}
      />

      {/* Dot grid sutil */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: 'radial-gradient(circle, #94d8f9 1px, transparent 1px)',
          backgroundSize: '28px 28px',
        }}
      />

      {/* Card */}
      <div className="relative z-10 w-full max-w-[400px] mx-4 animate-slide-up">
        <div className="rounded-3xl bg-white p-8 shadow-[0_32px_80px_-16px_rgba(0,0,0,0.6)] ring-1 ring-white/10">
          <Outlet />
        </div>
        <p className="mt-6 text-center text-xs text-white/20">
          © {new Date().getFullYear()} Cashless Escolar
        </p>
      </div>
    </div>
  );
}
